import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyStratalotVacantApiService } from './company-stratalot-vacant-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyStratalotVacantApiService extends GeneratedCompanyStratalotVacantApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
